<template>
  <v-app id="dashboard">
    <header-bar />
    <side-bar />
    <v-main width="100%" class="mb-10" style="background-color: #ecf0f5">
      <go-to-top-button />
      <warn-message class="mt-5" :messages="errorMessages" />
      <success-message class="mt-5" :messages="successMessages" />
      <error-message-dialog :messages="errorMessages" />
      <progress-dialog color="deep-orange lighten-2" />
      <router-view />
    </v-main>
    <footer-bar />
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import Store from '@/store';
import HeaderBar from '@/components/HeaderBar.vue';
import SideBar from '@/components/SideBar.vue';
import GoToTopButton from '@/components/GoToTopButton.vue';
import WarnMessage from '@/components/WarnMessage.vue';
import SuccessMessage from '@/components/SuccessMessage.vue';
import ErrorMessageDialog from '@/components/ErrorMessageDialog.vue';
import ProgressDialog from '@/components/dialog/ProgressDialog.vue';
import FooterBar from '@/components/FooterBar.vue';
import { signout } from '@/libs/common';
import { getSuccessMessageMap, getErrorMessageMap } from '@/libs/messages';

@Component({
  components: {
    HeaderBar,
    SideBar,
    GoToTopButton,
    WarnMessage,
    SuccessMessage,
    ErrorMessageDialog,
    ProgressDialog,
    FooterBar,
  },
})
export default class Dashboard extends Vue {
  get isExpiredSession(): boolean {
    return Store.getters.isExpiredSession;
  }

  get property() {
    return Store.getters.selectedProperty;
  }

  get successMessages() {
    return getSuccessMessageMap(this.property);
  }

  get errorMessages() {
    return getErrorMessageMap(this.property);
  }

  @Watch('isExpiredSession')
  public async watchExpiredSession(expired: boolean) {
    if (expired) {
      await signout();
      this.$router.push('/dashboard/login');
    }
  }
}
</script>

<style lang="scss" scoped>
#dashboard {
  /* Google fontsで導入したいfontsからfont-familyを取ってくる */
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 17px !important;
}

#dashboard::v-deep {
  .v-data-table {
    th {
      font-size: 14.5px !important;
    }
    td {
      font-size: 14px !important;
    }
    tbody tr:nth-of-type(odd) {
      background-color: rgb(250, 250, 250);
    }
    .active {
      border-left: thick solid #eaaa54;
    }
  }
  .required label::after {
    color: red;
    content: ' *';
  }
  .card-main {
    margin: 32px 12px;
  }
}
</style>
